import React, {Component} from 'react';
import {SortableContainer} from 'react-sortable-hoc';
import SortableQuizQuestion from './SortableQuizQuestion';

class SortableQuizContainer extends Component {
    render() {

        return (
            <div className="">
                {this.props.questions.map((question, i) => {
                    

                    return (

                        <SortableQuizQuestion
                            index={i}
                            key={i}
                            number={i}
                            question={question}
                            handleEditQuestionClick={this.props.handleEditQuestionClick}
                            handleDeleteModalShowState={this.props.handleDeleteModalShowState}
                            handleRewindTo={this.props.handleRewindTo}
                            isEditedInPreview={this.props.isEditedInPreview}
                            uploadQuestions={this.props.uploadQuestions}
                            

                        />

                    )

                })}
            </div>
        )
        

    }

}

export default SortableContainer(SortableQuizContainer);


// WEBPACK FOOTER //
// ./src/components/EditChapterPart/SortableQuizContainer.js